import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Skjul på bestillingssiden, da den har sit eget dedikerede kurv-flow og formular
  if (location.pathname === '/bestil-knolde') {
    return null;
  }

  return (
    <div
      className={`fixed bottom-6 right-6 z-40 transition-all duration-300 transform ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'
      }`}
    >
      <Link
        to="/bestil-knolde"
        className="bg-[#823f6e] hover:bg-[#70325f] text-white px-6 py-4 rounded-full shadow-2xl hover:shadow-dahlia-500/20 flex items-center gap-3 font-semibold tracking-wide transition-all duration-200 hover:-translate-y-1 group"
      >
        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
        </span>
        <span>Bestil Dahlia Knolde</span>
        <i className="fa-solid fa-arrow-right transition-transform group-hover:translate-x-1" />
      </Link>
    </div>
  );
}
